<button
  mat-button
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  aria-label="button with a menu"
  data-testid="header-menu"
  tabindex="0"
  >
  <span class="menu-button">
    Menu
  </span>
</button>
<mat-menu #menu="matMenu" class="header-menu">

  @if (isDeviceSettingsButtonEnabled) {
    <button
      (click)="openChangeAudioVideoModal()"
      mat-menu-item
      data-testid="header-device-settings"
      class="header-menu-item"
      >
      <span><img src="/assets/icons/menu-device-settings-icon.svg" alt="Device Settings">
      Device Settings</span>
    </button>
  }
  @if (isDeviceSettingsButtonEnabled) {
    <mat-divider></mat-divider>
  }
  @if (isOrderDetailsButtonEnabled) {
    <button
      (click)="openDetailsModal()"
      mat-menu-item
      data-testid="header-order-details"
      class="header-menu-item"
      >
      <span><img src="/assets/icons/menu-order-details-icon.svg" alt="Order Details">
      Order Details</span>
    </button>
  }
  @if (isOrderDetailsButtonEnabled) {
    <mat-divider></mat-divider>
  }
  @if (isIdVerifyButtonEnabled) {
    <button
      (click)="openIdVerifyModal()"
      mat-menu-item
      data-testid="header-id-verify"
      class="header-menu-item"
      >
      <span><img src="/assets/icons/menu-id-verification-icon.svg" alt="ID Verify">
      ID Verify</span>
    </button>
  }
  @if (isIdVerifyButtonEnabled) {
    <mat-divider></mat-divider>
  }
  @if (isPrivacyPolicyButtonEnabled) {
    <a
      mat-menu-item
      class="header-menu-item"
      href="https://www.rocketclose.com/privacy-policy"
      target="_blank"
      data-testid="header-privacy-policy"
      rel="noopener"
      >
      <span><img src="/assets/icons/menu-privacy-policy-icon.svg" alt="Privacy Policy">
      Privacy Policy</span></a
      >
    }
    @if (isPrivacyPolicyButtonEnabled) {
      <mat-divider></mat-divider>
    }
    @if (isTermsOfUseButtonEnabled) {
      <a
        mat-menu-item
        class="header-menu-item"
        href="https://www.rocketclose.com/terms-of-use"
        target="_blank"
        data-testid="header-terms-of-use"
        rel="noopener"
        >
        <span><img src="/assets/icons/menu-terms-of-use-icon.svg" alt="Terms of Use">
        Terms Of Use</span></a
        >
      }
      @if (isTermsOfUseButtonEnabled) {
        <mat-divider></mat-divider>
      }
      @if (isCancelSigningButtonEnabled) {
        <button
          mat-menu-item
          (click)="openCancelSigningModal()"
          class="header-menu-item"
          data-testid="header-cancel-signing"
          >
          <span><img src="/assets/icons/menu-cancel-signing-icon.svg" alt="Cancel Signing">
          Cancel Signing</span>
        </button>
      }
      @if (isCancelSigningButtonEnabled) {
        <mat-divider></mat-divider>
      }
      @if (isPreSignLogoutButtonEnabled) {
        <div class="button-container" mat-menu-item>
          <app-button (click)="dispatchPreSignLogout()"
            [type]="'primary'"
            data-testid="presign-logout">
            Logout
          </app-button>
        </div>
      }
      @if (isPreSignLogoutButtonEnabled) {
        <mat-divider></mat-divider>
      }


    </mat-menu>
